/* eslint-disable react/prop-types */
import React from "react";
import { components } from "react-select";

import dropDownIndicator from "../../assets/images/arrow-down-new.svg";

export const EmptyDropdownIndicator = () => null;
export const EmptyIndicatorSeparator = () => null;
export const DropdownIndicator = props => {
  return (
    <components.DropdownIndicator {...props}>
      <img
        className="dropdown-indicator"
        alt="show list"
        src={dropDownIndicator}
      />
    </components.DropdownIndicator>
  );
};

export const CountryOption = props => {
  return (
    <components.Option {...props}>
      <span
        className={`flag-icon flag-icon-${props.data.code.toLowerCase()}`}
      ></span>
      <span>{props.label}</span>
    </components.Option>
  );
};

export const CountrySingleValue = props => {
  return (
    <components.SingleValue {...props}>
      <span
        className={`flag-icon flag-icon-${props.data.code.toLowerCase()}`}
      ></span>
      <span>{props.data.label}</span>
    </components.SingleValue>
  );
};

export const UserRoleOption = props => {
  return (
    <components.Option {...props}>
      <span>{props.label}</span>:{" "}
      <span
        style={{
          color: props.isFocused ? "#3965DE" : "#C0CCDF",
          fontWeight: "300"
        }}
      >
        {props.data.addition}
      </span>
    </components.Option>
  );
};
